exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1GargJd8XwVhMT72kGTR5X{cursor:pointer;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"link": "_1GargJd8XwVhMT72kGTR5X"
};